import { createContext } from "react";
import type { AuthMeResponse, CreateOrgResponse } from "./types";

export type AuthState = {
  user: AuthMeResponse | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  reload: () => Promise<void>;
  switchOrg: (orgId: number) => Promise<void>;
  createOrg: (name: string, timezone?: string) => Promise<CreateOrgResponse>;
};

export const AuthContext = createContext<AuthState | null>(null);
